import React from "react"
import PropTypes from "prop-types"
import parse from "html-react-parser"
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion"
import * as styles from "./__styles__/accordion.module.scss"

export default function AccordionComponent({ accordion }) {
  return (
    <div className={styles.accordion}>
      <Accordion allowZeroExpanded={true} allowMultipleExpanded={true}>
        {accordion.map((row, index) => (
          <AccordionItem key={index} className={styles.row}>
            <AccordionItemHeading>
              <AccordionItemButton className={styles.button}>
                {row.title}
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel className={styles.panel}>
              {parse(row.description)}
            </AccordionItemPanel>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  )
}

AccordionComponent.propTypes = {
  /**
   * Accordion elements (array of objects)
   */
  accordion: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
    })
  ),
}
